import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useNavigate } from 'react-router-dom'
import { useHistory } from 'shared/hooks/useHistory'
import { useUserContext } from 'shared/hooks/useUserContext'
import { useCommonStore } from 'shared/stores/commonStore'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { FullPageAppTemplate } from '../templates'

const SettingsApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const isInternalUser = useCommonStore(state => state.isInternalUser)
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.SETTINGS}
        scope='settings'
        envKey={apps[AppId.SETTINGS].runtimeEnvKey}
        entryPath='./SettingsApp'
        url={process.env.REACT_APP_SETTINGS_APP_DEV_PATH}
        appName={apps[AppId.SETTINGS].name}
        appProps={{
          user,
          history,
          appPath: apps[AppId.SETTINGS].path,
          initialPath: location.pathname,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          },
          isInternalUser: isInternalUser([], true)
        }}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)

export { SettingsApp }
